import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=2957883a&scoped=true"
import script from "./NavigationDrawer.vue?vue&type=script&lang=js"
export * from "./NavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawer.vue?vue&type=style&index=0&id=2957883a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2957883a",
  null
  
)

export default component.exports